import { Component, NgZone, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { AppdataService } from 'src/app/services/app-data/appdata.service';
import { WebsocketService } from 'src/app/services/websockets/websocket.service';
import { $b } from '../../../libs/browser_utils.js';
import { LivechatStartService } from 'src/app/services/livechat-start/livechat-start.service';
import { CommunicationInterfaceService } from 'src/app/services/communicationInterface/communication-interface.service';
import { MessengerService } from 'src/app/services/messenger/messenger.service';


@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WelcomeComponent implements OnInit {
  logoImg: any;
  appConfig: any;
  isCaptchaEnabled: boolean;
  encryptKey = 'ThisIsTheSecret';
  version: string;

  constructor(
    private route: Router,
    private appDataService: AppdataService,
    private websocketService: WebsocketService,
    public zone: NgZone,
    private startService: LivechatStartService,
    private commInterface: CommunicationInterfaceService,
    public messengerService: MessengerService,
  ) {
    this.commInterface.logToServer('info', 'WelcomeComponent.constructor', 'WelcomeComponent initiated');
  }

  ngOnInit(): void {
    try {
      this.appConfig = this.appDataService.getConfig();
      this.version = this.appDataService.getAppVersion();
      this.logoImg = this.appConfig.welcomeLogo;
      this.isCaptchaEnabled = this.commInterface.isCaptchaEnabledFromBackend;

      if (history.state && history.state.reload) {
        location.reload();
        this.commInterface.logToServer('info', 'WelcomeComponent.ngOnInit', 'Reloading location');
      } else {
        if($b.GetSessionStorage('sessionStarted')) return;
        if(this.messengerService.repeatedSession) return;

        if (this.isCaptchaEnabled === true) {
          setTimeout(() => {
            const navigationExtras: NavigationExtras = {
              queryParamsHandling: 'preserve',
              preserveFragment: true,
              queryParams: { ...this.startService.queryParameters }
            };
            this.zone.run(() => {
              this.route.navigate(['/captcha'], navigationExtras);
            });
            this.commInterface.logToServer('info', 'WelcomeComponent.ngOnInit', 'Routing to captcha');
          }, 3000);
        } else {
          if (this.appConfig.websocket.enabled) {
            this.websocketService.startWebSocket();
            this.commInterface.logToServer('info', 'WelcomeComponent.ngOnInit', 'Starting websocket');
          }
        }
      }


       /**
       * Subscribing for the livechat callback events and then handling different scenarios
       */
       this.commInterface.callbacksObservable.subscribe((callbackData) => {
        console.log('CallbackData', callbackData);
        this.commInterface.logToServer('info', 'AppComponent.callbacksObservable', JSON.stringify(callbackData));      
          switch (callbackData.callbackName) {
            case 'CaptchaEnabledStatus':
              this.isCaptchaEnabled = callbackData.params;
              console.log("IsCaptchaDisabled from Tcomm ", this.isCaptchaEnabled );
               // Check if Captcha is Enabled and route to captcha
              // if (this.isCaptchaEnabled === true) {
              //   setTimeout(() => {
              //     this.zone.run(() => {
              //       this.route.navigate(['captcha'], {
              //         queryParams: { ...this.startService.queryParameters },
              //         queryParamsHandling: 'preserve'
              //       });
              //     });
              //   }, 100);
              // } else {
              //   this.startService.checkforLivechatStart('');
              // }
              break;
            }
          });
    } catch (error) {
      console.error('%c Error Occured in ngOnInit', 'color: red', error);
      this.commInterface.sendUIErrors('WelcomeComponent', 'ngOnInit', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in WelcomeComponent.ngOnInit', JSON.stringify(error));
    }
  }

  /**
   * Decrypt the app-config fetched from localstorage
   */
  decryptAppConfig() {
    const decryptData = CryptoJS.AES.decrypt($b.GetLocalStorage('appconfig'), this.encryptKey);
    const obj = JSON.parse(decryptData.toString(CryptoJS.enc.Utf8));
    this.appConfig = obj;
  }
}
